module.exports = __webpack_public_path__ + "static/media/furvac360-1.f9bb059e.jpg";